import React, { useCallback, useState } from 'react';
import { Modal } from 'reactstrap';
import { useNavigation } from '../../../shared/utils/useNavigation';
import { copyTextToClipboard } from '../../../shared/utils/function';
import { reportError } from '../../../shared/sentry';

const COMPLETE_FORM_TITLE = 'Complete Form';
const COMPLETE_FORM_BODY =
  'Please sign the required tax form. If the link doesn\'t open after clicking Sign Form, click Copy below and paste it into your browser.';

/**
 * Modal shown after submitting W-8 or W-9 when e-signature is pending.
 * No Cancel option — only "Sign Form" and "Copy".
 */
const CompleteFormModal = ({
  isOpen,
  signingUrl,
  isUsUser = false,
  onSignFormNavigate
}) => {
  const navigate = useNavigation();
  const [hasCopied, setHasCopied] = useState(false);

  const handleSignForm = useCallback(() => {
    if (!signingUrl) return;
    if (typeof onSignFormNavigate === 'function') {
      onSignFormNavigate();
    }
    navigate.toWebView(signingUrl, isUsUser ? 'W-9 Tax Sign Form' : 'W-8 Tax Sign Form');
  }, [signingUrl, isUsUser, navigate, onSignFormNavigate]);

  const handleCopy = useCallback(async () => {
    if (!signingUrl) return;
    try {
      const didCopy = await copyTextToClipboard(signingUrl, 'Copy this signing link:');
      if (didCopy) {
        setHasCopied(true);
        window.setTimeout(() => setHasCopied(false), 2000);
      }
    } catch (err) {
      reportError(err, 'CompleteFormModal copy signing url');
    }
  }, [signingUrl]);

  if (!signingUrl) return null;

  return (
    <Modal
      isOpen={isOpen}
      centered
      className="cm_g_modal_wrapper"
      backdrop="static"
      keyboard={false}
    >
      <div className="cm_g_modal_header">
        <h3>{COMPLETE_FORM_TITLE}</h3>
      </div>
      <div className="cm_g_modal_body">
        <div className="cm_inner_modal_scroll_div">
          <p className="mb-4">{COMPLETE_FORM_BODY}</p>
          <div className="d-flex flex-row gap-2 flex-wrap">
            <button
              type="button"
              className="btn btn_primary rounded_8"
              onClick={handleSignForm}
            >
              Sign Form
            </button>
            <button
              type="button"
              className="btn btn_dark_outline rounded_8"
              onClick={handleCopy}
              aria-label="Copy signing link"
            >
              {hasCopied ? 'Copied' : 'Copy'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CompleteFormModal;
